<div>
    <div class="absolute inset-0 bg-primary"></div>

    <div class="relative flex min-h-screen items-center justify-center px-6 py-10 dark:bg-[#060818] sm:px-16">
        <div
            class="relative w-full max-w-[870px] rounded-md bg-[linear-gradient(45deg,#fff9f9_0%,rgba(255,255,255,0)_25%,rgba(255,255,255,0)_75%,_#fff9f9_100%)] p-2 dark:bg-[linear-gradient(52.22deg,#0E1726_0%,rgba(14,23,38,0)_18.66%,rgba(14,23,38,0)_51.04%,rgba(14,23,38,0)_80.07%,#0E1726_100%)]"
        >
            <div class="relative flex flex-col justify-center rounded-md bg-white/60 px-6 py-20 backdrop-blur-lg dark:bg-black/50 lg:min-h-[758px]">
                <div class="mx-auto w-full max-w-[440px]">
                    <div class="mb-10 flex items-center">
                        <div class="flex h-16 w-16 items-end justify-center overflow-hidden rounded-full bg-[#00AB55] ltr:mr-4 rtl:ml-4">
                            <img src="/assets/images/favico.png" class="w-full object-cover" alt="images" />
                        </div>
                        <div class="flex-1">
                            <h4 class="text-2xl dark:text-white">UPSEE</h4>
                            <p class="text-white-dark">Entre com o código de 6 dígitos enviado por email</p>
                        </div>
                    </div>
                    <form class="space-y-5" [formGroup]="codeAuthForm" (submit)="submit()">
                        <div>
                            <label for="codeAuth" class="dark:text-white">Código de Autenticação</label>
                            <div class="relative text-white-dark">
                                <input
                                    id="codeAuth"
                                    type="text"
                                    placeholder="Código de 6 dígitos"
                                    formControlName="code"
                                    class="form-input ps-10 placeholder:text-white-dark"
                                    minlength="6"
                                    maxlength="6"
                                    required
                                />
                                <span class="absolute start-4 top-1/2 -translate-y-1/2">
                                    <icon-lock-dots [fill]="true" />
                                </span>
                            </div>
                            <div
                                class="invalid-feedback"
                                *ngIf="codeAuthForm.get('code')?.invalid && (codeAuthForm.get('code')?.dirty || codeAuthForm.get('code')?.touched)"
                            >
                                <div *ngIf="f['code'].errors?.['required']">Email obrigatório</div>
                                <div *ngIf="f['code'].errors?.['code']">Email inválido</div>
                            </div>
                        </div>
                        <button
                            type="submit"
                            [disabled]="codeAuthForm.invalid"
                            class="btn btn-gradient !mt-6 w-full border-0 uppercase shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]"
                        >
                            Enviar
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
